import axios from "axios";

// Use environment variable for backend API URL
const baseURL =
  process.env.REACT_APP_BACKEND_API_URL !== undefined &&
  process.env.REACT_APP_BACKEND_API_URL !== null &&
  process.env.REACT_APP_BACKEND_API_URL !== ""
    ? process.env.REACT_APP_BACKEND_API_URL
    : ""; // same-origin in prod builds

const instance = axios.create({
  baseURL,
  withCredentials: true,
  xsrfCookieName: "csrftoken",
  xsrfHeaderName: "X-CSRFToken",
});

// ✅ Attach token + blog header to every request if it exists
instance.interceptors.request.use((config) => {
  const token = localStorage.getItem("access_token");

  if (token) {
    config.headers.Authorization = `Token ${token}`;
  }

  const publicPaths = ["/api/login/", "/api/password-reset/", "/api/password-reset/confirm/"];
  const isPublic = publicPaths.some((p) => (config.url || "").includes(p));
  if (!token && !isPublic) {
    console.warn("Axios request made without token:", config.url);
  }

  // ✅ Blog scoping header (fallback order):
  // 1) selected_blog.id (your existing pattern)
  // 2) blog_id
  // 3) "1" (dev fallback)
  let blogId = null;

  try {
    const selected = JSON.parse(localStorage.getItem("selected_blog"));
    if (selected?.id) blogId = selected.id;
  } catch (e) {
    // ignore parse errors
  }

  if (!blogId) {
    blogId = localStorage.getItem("blog_id") || "1";
  }

  config.headers["X-Blog-ID"] = blogId;

  return config;
});

instance.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      localStorage.removeItem("access_token");
      window.location.replace("/login");
    }
    return Promise.reject(err);
  }
);

export default instance;
